(function () {
  function init(root) {
    var formId = root.getAttribute('data-product-form');
    var form = formId ? document.getElementById(formId) : null;
    var qtyInput = form ? form.querySelector('#quantity, input[name="quantity"]') : document.querySelector('#quantity, input[name="quantity"]');

    root.querySelectorAll('[data-bundle-option]').forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.preventDefault();
        root.querySelectorAll('[data-bundle-option]').forEach(function (el) {
          el.classList.remove('is-selected');
          var radio = el.querySelector('input[type="radio"]');
          if (radio) radio.checked = false;
        });
        option.classList.add('is-selected');
        var radio = option.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;

        var qty = parseInt(option.getAttribute('data-qty'), 10) || 1;
        if (qtyInput) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    });
  }

  document.querySelectorAll('[data-bundle-picker]').forEach(init);

  document.addEventListener('shopify:section:load', function (evt) {
    evt.target.querySelectorAll('[data-bundle-picker]').forEach(init);
  });
})();
